import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import PanelWiseRateTab from './tabs/PanelWiseRateTab';

export const PanelRatePage = ({ showToast }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const initialPanelId = searchParams.get('panelId') ? parseInt(searchParams.get('panelId'), 10) : null;

  return (
    <div className="page-container fade-in">
      {/* One slim row on top: the way back. The title and the actions are in the rate list below. */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', marginBottom: '0.75rem' }}>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => navigate('/masters/panels')}
          style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}
        >
          ← Back to Panel Master
        </button>
      </div>

      <div className="glass-card fade-in" style={{ padding: '1.5rem' }}>
        <PanelWiseRateTab showToast={showToast} initialPanelId={initialPanelId} />
      </div>
    </div>
  );
};

export default PanelRatePage;
